import hive from './hive';

const accountExists = account => {
  return hive.api
    .getAccountsAsync([account])
    .then(r => {
      if (r.length > 0) return true;
      return false;
    })
    .catch(err => console.log(err));
};

export default accountExists;
